module.exports = __webpack_public_path__ + "img/02_Calming Presence.2f8eb297.svg";